// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3c335ab8] .el-dialog {\n  max-width: 500px;\n}\n[data-v-3c335ab8] .el-dialog__body {\n  margin-bottom: -20px;\n}", ""]);
// Exports
module.exports = exports;
